import React from 'react';

/**
 * Content for the Step 4 service treatment records (STR) screens (#155984).
 */

// Shown when the Veteran chooses to submit their STR later. Same copy as the
// live 526 (all-claims) service treatment records page.
export const serviceTreatmentRecordsSubmitLater = (
  <div id="submit-str-asap" className="vads-u-margin-top--3">
    <va-alert status="warning" uswds>
      <h3 slot="headline">
        Please submit your service treatment records as soon as possible
      </h3>
      <p className="vads-u-font-size--base vads-u-margin-y--0">
        You don’t have to turn in your service treatment records with your
        application, but your eligibility for the BDD program could expire if
        there is a delay in us receiving them.
      </p>
    </va-alert>
  </div>
);
